import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import BaiduMap from 'vue-baidu-map'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
Vue.use(ElementUI);

Vue.use(BaiduMap, {
  ak: 'LnbCTxiG0HiNvqnniaiuOAPR5fwX5USq'  //  在此输入你自己的百度地图ak
})

Vue.config.productionTip = false

router.afterEach((to, from) => {
  to
  from
  window.scrollTo(0, 0);
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
